// @flow

import React, {Component} from 'react'
import {map} from 'ramda'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import type {Language} from '@/types'
import {getElementIdName} from '@/views/util'

type Props = {
  label: string,
  selected: ?string,
  options: Array<Object>,
  onChange: (string) => void,
  disable?: boolean,
  l: Language,
}

const renderOption = (l) => ({key, value, disabled}) =>
  <option key={key} value={key} disabled={disabled}>{l(value)}</option>

export class RawSelector extends Component<Props> {
  onChange = ({currentTarget}: SyntheticEvent<*>) => {
    this.props.onChange(String(currentTarget.value))
  }

  render = () =>
    <label>{this.props.l(this.props.label)}
      <select
        className="form-control"
        value={this.props.selected}
        onChange={this.onChange}
        disabled={this.props.disable}
        id={getElementIdName(this.props.label)}
      >
        {map(renderOption(this.props.l), this.props.options)}
      </select>
    </label>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawSelector)



// WEBPACK FOOTER //
// ./src/controls/selector.js